import React, {useEffect, useState} from 'react';
import _ from "lodash";
import Promise from "bluebird";
import {getExternalImageDownloadUrl} from "../../../common/services/cloud-function-service";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import {updateSingleParentProduct} from "../../../pod/services/parent-product-data-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const ParentProductTemplates = ({
                                    parentProduct,
                                    templateImage,
                                    setTemplateImage
                                }) => {
    const [templatesImages, setTemplatesImages] = useState([]);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(false);

    useEffect(() => {
        prepareTemplateImageUrls();
    }, [parentProduct?.id]);

    const prepareTemplateImageUrls = async () => {
        setDataFetchInProgress(true);
        const newTemplatesImages = [];
        const existingParentProduct = {...parentProduct};

        if (!existingParentProduct?.templatesImages) {
            await Promise.each(existingParentProduct?.layout?.templates, async (template) => {
                const templateImage: any = {};
                const templateImageUrl = await getExternalImageDownloadUrl(template?.image_url, template?.template_id, 'template');
                console.log('templateImageDataUrl', templateImageUrl);
                templateImage.src = templateImageUrl;
                templateImage.width = template?.print_area_width;
                templateImage.height = template?.print_area_height;
                templateImage.opacity = 100;
                templateImage.fillPatternOffsetX = template?.print_area_left;
                templateImage.fillPatternOffsetY = template?.print_area_top;
                templateImage.fillPatternRotation = 0;
                templateImage.x = template?.print_area_left;
                templateImage.y = template?.print_area_top;
                templateImage.template_id = template?.template_id;

                newTemplatesImages.push(templateImage);
            });

            setTemplatesImages(newTemplatesImages);
            existingParentProduct.templatesImages = newTemplatesImages;
            await updateSingleParentProduct(existingParentProduct);
        } else {
            setTemplatesImages(existingParentProduct?.templatesImages);
        }

        console.log('newTemplatesImages', newTemplatesImages);

        setTemplateImage(existingParentProduct?.templatesImages[0]);
        setDataFetchInProgress(false);
    }

    return (
        <>
            <div
                className="select-images-table-container w-64 flex flex-wrap content-start justify-center overflow-y-scroll p-4 border border-gray-400 bg-gray-400 rounded-lg">
                {dataFetchInProgress &&
                    <div className="my-4 flex content-start items-start justify-center">
                        <div>
                            <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                        </div>
                    </div>
                }

                {templatesImages?.length > 0 &&
                    <>
                        {templatesImages?.map((templatesImageItem, templatesImageIndex) => (
                            <div key={templatesImageIndex}>
                                <ProductImageSmall
                                    afterImageSelected={(event) => {
                                        // handleSelectedProductImageInLayer(productImage)
                                        setTemplateImage(templatesImageItem);
                                    }}
                                    dimension={200}
                                    label={templatesImageItem?.template_id}
                                    isSelected={templatesImageItem?.template_id === templateImage?.template_id}
                                    key={`template-image-${templatesImageIndex}`}
                                    imageUrl={templatesImageItem?.src}/>
                            </div>
                        ))}
                    </>
                }
            </div>
        </>
    )
}

export default ParentProductTemplates
